/**
 * Different types of filters (operands) in a DSL expression
 */
const FILTER_TYPES = {
  ATTRIB: 1,
  EXACT: 2,
  FUZZY: 3
};

module.exports = FILTER_TYPES;



// WEBPACK FOOTER //
// ./src/js/constants/DSLFilterTypes.js